import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { useState } from 'react';

export default function UnavailableOnlineOrder(props: { website: string }) {
  const [isOpen, setIsOpen] = useState<boolean>(true);
  return (
    <Dialog className="unavailable-online-order relative z-10" open={isOpen} onClose={() => {setIsOpen(false)}}>
      <DialogBackdrop
        transition
        className="unavailable-online-order__backdrop fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />

      <div className="unavailable-online-order__overlay fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="unavailable-online-order__container flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <DialogPanel
            transition
            className="unavailable-online-order__panel relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-sm sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
          >
            <div className="unavailable-online-order__content">
              <div className="unavailable-online-order__icon-container mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-red-100">
                <ExclamationTriangleIcon className="unavailable-online-order__icon h-6 w-6 text-red-600" aria-hidden="true" />
              </div>
              <div className="unavailable-online-order__text mt-3 text-center sm:mt-5">
                <DialogTitle as="h3" className="unavailable-online-order__title text-base font-semibold leading-6 text-gray-900">
                  This store is not available for online order.
                </DialogTitle>
                <div className="unavailable-online-order__description mt-2">
                  <p className="unavailable-online-order__message text-sm text-gray-500">Please try later</p>
                </div>
              </div>
            </div>
            <div className="unavailable-online-order__actions mt-5 sm:mt-6">
              <a
                className="unavailable-online-order__button inline-flex w-full justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                href={props.website}
              >
                Go back to restaurant page
              </a>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
}

{
  /* <div>This store is not available for online order</div> */
}